export default __webpack_public_path__ + "static/media/none-paired-icon.b094a577.svg";